exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsearch-bar__search input[data-v-36a3c425]::-webkit-input-placeholder {\n\tcolor: #797979;\n}\nsearch-bar__search input[data-v-36a3c425]::-moz-placeholder {\n\tcolor: #797979;\n}\nsearch-bar__search input[data-v-36a3c425]:-ms-input-placeholder {\n\tcolor: #797979;\n}\nsearch-bar__search input[data-v-36a3c425]::-ms-input-placeholder {\n\tcolor: #797979;\n}\nsearch-bar__search input[data-v-36a3c425]::placeholder {\n\tcolor: #797979;\n}\n", ""]);

// exports
